import { Roles } from '@/utils/auth/roles';
import StoreBuilder from '../store-builder';
import { TiersApi } from '@/api/tiers';
import { UserApi } from '@/api/user';

const builder = new StoreBuilder('user');
builder.addStatePart('user', null, () => UserApi.getProfil(), 'NONE', 1800);
builder.setGetters({
  username: (state: any) => state.user?.username,
  isTiers: (state: any) => state.user ? (state.user.roles.indexOf(Roles.USER_ADHERENT) !== -1) : undefined
});

builder.addStatePart('listeRegionUser', null, () => TiersApi.getInfosUser(), 'SESSION', 1800);
builder.addStatePart('regionSelectionnee', null, null, 'SESSION');
builder.addStatePart('infosContact', null, () => UserApi.getInfosContact(), 'SESSION', 1800);

export default builder.build();
